import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText } from 'lucide-react';
export function WhatIncludes() {
  const items = ['PDF principal con el Sistema 3 Puertas (paso a paso).', 'Tarjetas imprimibles para usar en el momento del bloqueo.', 'Checklist 14 días: Proyectos del Día (para crear consistencia sin perfección).', "Plantilla bonus 'Cuando no entiendo' (para convertir confusión en primer paso)."];
  return <section className="py-24 px-4 bg-dark-900 border-t border-white/5" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-177">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2" data-id="element-178">
            <div className="relative aspect-[3/4] bg-dark-800 rounded-lg border border-white/10 flex items-center justify-center overflow-hidden group" data-id="element-179">
              <div className="absolute inset-0 bg-amber-500/5 group-hover:bg-amber-500/10 transition-colors" data-id="element-180" />
              <FileText size={80} className="text-amber-700/50" data-id="element-181" />
              <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-dark-900 to-transparent" data-id="element-182">
                <p className="text-amber-gold font-bold text-center" data-id="element-183">
                  EL MIEDO DIARIO
                </p>
              </div>
            </div>
          </motion.div>

          <div className="w-full md:w-1/2" data-id="element-184">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl font-bold text-white mb-8" data-id="element-185">
              Qué incluye exactamente
            </motion.h2>

            <ul className="space-y-6" data-id="element-186">
              {items.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-187">
                  <div className="mt-1 bg-amber-500/20 p-1 rounded-full text-amber-500 shrink-0" data-id="element-188">
                    <Check size={16} strokeWidth={3} data-id="element-189" />
                  </div>
                  <span className="text-gray-300 text-lg leading-relaxed" data-id="element-190">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}